/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  CapabilityCard,
  CapabilityCardPortalPreview
} from '@thd-olt-component-react/capability_card';

export const getCardId = (card, cardKey) => card.id || card.sys?.id || `capability-card-${cardKey}`;

export const CapabilityCardItem = ({
  card,
  cardId,
  cardKey,
  isPortalLivePreview = false,
  enableB2CRadius = false
}) => (
  isPortalLivePreview
    ? (
      <CapabilityCardPortalPreview
        componentId={cardId}
        componentClass="CapabilityCard"
        portalPreviewData={card}
        isHorizontal
      />
    ) : (
      <CapabilityCard
        headline={card.headline}
        richText={typeof card.richTextContent === 'string'
          ? card.richTextContent
          : JSON.stringify(card.richTextContent?.json)}
        componentPosition={cardKey + 1}
        componentId={cardId}
        enableB2CRadius={enableB2CRadius}
      />
    )
);

CapabilityCardItem.propTypes = {
  card: PropTypes.shape({
    headline: PropTypes.string,
    richTextContent: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        json: PropTypes.shape({})
      })
    ])
  }).isRequired,
  cardId: PropTypes.string.isRequired,
  cardKey: PropTypes.number.isRequired,
  isPortalLivePreview: PropTypes.bool,
  enableB2CRadius: PropTypes.bool
};

export default CapabilityCardItem;
